import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/veteran-app/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_veteran text_veteran"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h1>
              The Veteran App-Helping The Community That Served Our Nation
            </h1>
            <p>
              This app was designed to serve just one purpose – To help Veterans
              in any way we can!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/veteran-app/banner_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={662}
                height={776}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
